module.exports = __webpack_public_path__ + "static/media/beneath_the_dark.791958e5.mp3";